import { render, staticRenderFns } from "./Create-Salary.vue?vue&type=template&id=3dc6bb23&"
import script from "./Create-Salary.vue?vue&type=script&lang=js&"
export * from "./Create-Salary.vue?vue&type=script&lang=js&"
import style0 from "./Create-Salary.vue?vue&type=style&index=0&id=3dc6bb23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports